import { useLoadBoardServicesQuery } from '../queries/useLoadBoardServicesQuery';

import { createMutationHook } from '~/shared/providers/api';

export const useRouteUnassignMutation = createMutationHook(
  'transportation.routeUnassign',
  (params: { id: string }) => ({
    transportationRouteUnassign: {
      __args: { id: params.id },
      id: true,
      assignmentStatus: true,
    },
  }),
  {
    invalidateQueries: [useLoadBoardServicesQuery],
  },
);
